import React from 'react';

interface PhoneIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

const PhoneIcon: React.FC<PhoneIconProps> = ({ size = 25, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      {...props}
    >
      <path
        d="M5.32667 10.8867C7.24667 14.66 10.34 17.7533 14.1133 19.6733L17.0467 16.74C17.42 16.3667 17.94 16.26 18.4067 16.4067C19.9 16.9 21.5 17.1667 23.1667 17.1667C23.9 17.1667 24.5 17.7667 24.5 18.5V23.1667C24.5 23.9 23.9 24.5 23.1667 24.5C10.6467 24.5 0.5 14.3533 0.5 1.83333C0.5 1.1 1.1 0.5 1.83333 0.5H6.5C7.23333 0.5 7.83333 1.1 7.83333 1.83333C7.83333 3.5 8.1 5.1 8.59333 6.59333C8.74 7.06 8.63333 7.58 8.26 7.95333L5.32667 10.8867Z"
        fill="#27788C"
        stroke="black"
      />
    </svg>
  );
};

export default PhoneIcon;
